import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { Badge } from '@/components/ui/badge';

interface LoyaltyTierFilterProps {
  selectedValues: string[];
  onChange: (value: string, checked: boolean) => void;
}

const LoyaltyTierFilter: React.FC<LoyaltyTierFilterProps> = ({
  selectedValues,
  onChange
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Label className="text-base">Filter by Loyalty Program</Label>
        <Badge variant="outline" className="bg-gray-100 text-gray-500">Coming Soon</Badge>
      </div>
      <div className="flex flex-col gap-4 opacity-50 w-full">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="loyalty-bronze" 
            checked={selectedValues.includes('bronze')}
            onCheckedChange={(checked) => onChange('bronze', checked === true)}
            disabled={true}
          />
          <label
            htmlFor="loyalty-bronze"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Bronze Tier
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="loyalty-silver" 
            checked={selectedValues.includes('silver')}
            onCheckedChange={(checked) => onChange('silver', checked === true)}
            disabled={true}
          />
          <label
            htmlFor="loyalty-silver"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Silver Tier
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="loyalty-gold" 
            checked={selectedValues.includes('gold')}
            onCheckedChange={(checked) => onChange('gold', checked === true)}
            disabled={true}
          />
          <label
            htmlFor="loyalty-gold"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Gold Tier
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="loyalty-none" 
            checked={selectedValues.includes('none')}
            onCheckedChange={(checked) => onChange('none', checked === true)}
            disabled={true}
          />
          <label
            htmlFor="loyalty-none"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            No Loyalty Program
          </label>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyTierFilter;